import {
  Divider,
  type StackProps,
  Text,
  VStack,
} from '@adc/parallax-component-library';

import { Button } from '~/components/utility';
import { buildTestId } from '~/utilities/buildTestId';

type FooterCommon = {
  padding?: StackProps['padding'];
};

type FooterWithChildren = {
  children: React.ReactElement;
};

type FooterWithButtons = {
  children?: never;

  disabled?: boolean;
  buttonLabel: string;
  buttonTestID?: string;
  onButtonPress: () => void;

  /**
   * All secondary props need to be present for this section to show up!
   */
  secondarySectionLabel?: string;
  /**
   * All secondary props need to be present for this section to show up!
   */
  secondaryButtonLabel?: string;
  /**
   * All secondary props need to be present for this section to show up!
   */
  secondaryButtonTestID?: string;
  /**
   * All secondary props need to be present for this section to show up!
   */
  onSecondaryButtonPress?: () => void;
};

type FooterProps = FooterCommon & (FooterWithChildren | FooterWithButtons);

export const Footer = (props: FooterProps) => {
  if (props.children) {
    const { children, padding } = props;

    return (
      <VStack padding={padding} width="100%">
        {children}
      </VStack>
    );
  }

  const {
    padding,
    buttonLabel,
    buttonTestID,
    onButtonPress,
    disabled,
    onSecondaryButtonPress,
    secondarySectionLabel,
    secondaryButtonTestID,
    secondaryButtonLabel,
  } = props;

  const hasSecondarySetup =
    onSecondaryButtonPress &&
    secondaryButtonLabel &&
    secondarySectionLabel &&
    secondaryButtonTestID;

  return (
    <VStack padding={padding} width="100%">
      <Button
        onPress={onButtonPress}
        testID={buttonTestID}
        disabled={disabled}
        aria-label={buttonLabel}
        label={buttonLabel}
      />
      {hasSecondarySetup && (
        <>
          <Divider marginTop="$6" marginBottom="$4" borderColor="$neutral.40" />
          <VStack alignItems="center">
            <Text
              type="$bodySmall.default"
              testID={buildTestId({
                testID: secondaryButtonTestID,
                suffix: 'label',
              })}
            >
              {secondarySectionLabel}
            </Text>
            <Button
              variant="tertiary"
              label={secondaryButtonLabel}
              onPress={onSecondaryButtonPress}
              testID={secondaryButtonTestID}
            />
          </VStack>
        </>
      )}
    </VStack>
  );
};
